import { db } from '../firebase.js'; // Assuming db is exported from firebase.js
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  orderBy,
  serverTimestamp // Optional: To record creation/update times
} from 'firebase/firestore';

// Reference to the 'categories' collection in Firestore
const categoriesCollectionRef = collection(db, 'categories');

// Get all categories, ordered by name
export const getAllCategories = async () => {
  try {
    const q = query(categoriesCollectionRef, orderBy('name'));
    const querySnapshot = await getDocs(q);
    const categories = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    return categories;
  } catch (error) {
    console.error("Error fetching categories: ", error);
    throw new Error("Failed to fetch categories from Firestore.");
  }
};

// Add a new category
export const addCategory = async (categoryData) => {
  try {
    const docRef = await addDoc(categoriesCollectionRef, {
      ...categoryData,
      createdAt: serverTimestamp() // Optional: Add a timestamp
    });
    return docRef.id; // Return the new category's ID
  } catch (error) {
    console.error("Error adding category: ", error);
    throw new Error("Failed to add category to Firestore.");
  }
};

// Update an existing category
export const updateCategory = async (categoryId, updatedData) => {
  try {
    const categoryDocRef = doc(db, 'categories', categoryId);
    await updateDoc(categoryDocRef, {
        ...updatedData,
        updatedAt: serverTimestamp() // Optional: Update timestamp
    });
  } catch (error) {
    console.error("Error updating category: ", error);
    throw new Error("Failed to update category in Firestore.");
  }
};

// Delete a category
export const deleteCategory = async (categoryId) => {
  // TODO: Consider implications - what happens to articles linked to this category?
  // Maybe prevent deletion if articles are linked, or provide an option to reassign articles.
  // For now, it just deletes the category document.
  try {
    const categoryDocRef = doc(db, 'categories', categoryId);
    await deleteDoc(categoryDocRef);
  } catch (error) {
    console.error("Error deleting category: ", error);
    throw new Error("Failed to delete category from Firestore.");
  }
};

// --- Relationship Management (Placeholder - Needs Article Service) ---

// Function to link an article to a category (Example - adjust based on your data model)
// This might involve updating an array of article IDs in the category document,
// or updating a category ID field in the article document.
export const linkArticleToCategory = async (categoryId, articleId) => {
    console.log(`TODO: Link article ${articleId} to category ${categoryId}`);
    // Example: Update category document with article ID
    // const categoryDocRef = doc(db, 'categories', categoryId);
    // await updateDoc(categoryDocRef, {
    //     articles: arrayUnion(articleId) // Assumes 'articles' is an array field
    // });
    // Or: Update article document with category ID
    // const articleDocRef = doc(db, 'articles', articleId); // Assuming 'articles' collection
    // await updateDoc(articleDocRef, {
    //     categoryId: categoryId
    // });
};

// Function to unlink an article from a category (Example)
export const unlinkArticleFromCategory = async (categoryId, articleId) => {
    console.log(`TODO: Unlink article ${articleId} from category ${categoryId}`);
     // Example: Update category document
    // const categoryDocRef = doc(db, 'categories', categoryId);
    // await updateDoc(categoryDocRef, {
    //     articles: arrayRemove(articleId)
    // });
     // Or: Update article document
    // const articleDocRef = doc(db, 'articles', articleId);
    // await updateDoc(articleDocRef, {
    //     categoryId: null // Or remove the field
    // });
};
